import { render } from "./SkillsSetupModal.vue?vue&type=template&id=3e3fd902&ts=true"
import script from "./SkillsSetupModal.vue?vue&type=script&lang=ts"
export * from "./SkillsSetupModal.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__